<template>
  <div>
    <!-- 제목 -->
    <v-row class="title-wrap fixed">
      <v-col cols="12" class="icon-title word-type pb-5"
        ><icon-my-folder :width="24" :height="24" />{{ $t('참조함') }}</v-col
      >
    </v-row>

    <!-- 목록 -->
    <appl-doc-list
      class="overflow-y-auto"
      :style="scrollViewStyle"
      :searchReqGubun="'REFER'"
    />
  </div>
</template>

<script>
import ApplDocList from '@/components/allDoc/ApplDocList.vue';
import IconMyFolder from '@/assets/customIcon/IconMyFolder.vue';

export default {
  data: () => ({
    tab: null,
    tabGubun: {
      tab1: 'MYDOC', // 내문서
      //tab2: 'TEMP', // 임시저장문서
    },
  }),
  computed: {
    scrollViewStyle() {
      return `max-height: ${
        window.innerHeight - this.$store.getters.HEIGHT_TITLE_BOTTOM_NAV
      }px`;
    },
  },
  mounted() {
    this.$store.commit('ELA/RESET_ELA_STATE');
  },
  components: {
    ApplDocList,
    IconMyFolder,
  },
};
</script>

<style></style>
